interface CloudinaryImageLoaderParams {
  src: string;
  width?: number | "auto";
}

export const cloudinaryImageLoader = ({
  src,
  width = "auto",
}: CloudinaryImageLoaderParams): string => {
  return `https://img.peerspace.com/image/upload/f_auto,q_auto,dpr_auto,w_${width}/${src}`;
};

export const cloudinaryVendorImageLoader = ({
  src,
  width,
}: CloudinaryImageLoaderParams): string => {
  return `https://img.peerspace.com/image/upload/f_auto,q_auto,dpr_auto,ar_1.0,c_fill,g_center,w_${width}/${src}`;
};

export const cloudinaryImageLoaderWithWatermark = ({
  src,
  width = "auto",
}: CloudinaryImageLoaderParams): string => {
  return `https://img.peerspace.com/image/upload/f_auto,q_auto,dpr_auto,w_${width}/l_PS-logo,g_south_east,x_20,y_20,w_175,o_75/${src}`;
};

export const getLoader = (provider?: string) => {
  // check if provider is youtube, matterport, or vimeo
  if (provider) {
    return ({ src }: { src: string }) => src;
  }
  return cloudinaryImageLoader;
};

export const vendorPhotoLoader = ({
  src,
  width = "auto",
}: CloudinaryImageLoaderParams): string => {
  return `https://img.peerspace.com/image/upload/c_crop,g_custom/f_auto,q_auto,dpr_auto,c_scale,w_${width}/${src}`;
};
